import React, { FC } from "react";
import classNames from "classnames";
import { TwoColumnsList } from "../../models";
import { List } from "./components/List";

type Props = {
  lists: TwoColumnsList[];
};

export const SimpleTwoColumnsLists: FC<Props> = ({ lists }) => (
  <div
    className={classNames(
      "bg-dark px-5 py-20 text-primary-content",
      "lg:px-16 lg:py-25",
      "xl:px-24 xl:py-40",
    )}
  >
    <div
      className={classNames(
        "space-y-15",
        "lg:space-y-25",
        "xl:space-y-40",
        "xl:mx-auto xl:max-w-[1235px]",
      )}
    >
      {lists.map((list) => (
        <List key={list._uid} data={list} />
      ))}
    </div>
  </div>
);
